import Dexie, { type Table } from 'dexie';
import type { AttachmentRow, QueueEntry, ReferenceCacheRow } from './types';

export class MineTechDB extends Dexie {
  queue!: Table<QueueEntry, number>;
  attachments!: Table<AttachmentRow, number>;
  referenceCache!: Table<ReferenceCacheRow, number>;

  constructor() {
    super('MineTechDB');
    this.version(1).stores({
      // ++id = autoincrement; bracketed keys are compound indexes.
      queue: '++id, clientId, resource, status, createdAt, [resource+status]',
      attachments: '++id, clientId, kind, createdAt',
      referenceCache: '++id, resource, [resource+key]',
    });
  }
}

export const db = new MineTechDB();
